import { render, staticRenderFns } from "./Courseware.vue?vue&type=template&id=82669a8a&scoped=true&"
import script from "./Courseware.vue?vue&type=script&lang=js&"
export * from "./Courseware.vue?vue&type=script&lang=js&"
import style0 from "./Courseware.vue?vue&type=style&index=0&id=82669a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82669a8a",
  null
  
)

export default component.exports